interface ElementsIconProps {
  isActive?: boolean;
  className?: string;
}

const ElementsIcon = ({ isActive, className, ...rest }: ElementsIconProps) => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 15C0 11.0218 1.58035 7.20644 4.3934 4.3934C7.20644 1.58035 11.0218 0 15 0C18.9782 0 22.7936 1.58035 25.6066 4.3934C28.4196 7.20644 30 11.0218 30 15C30 18.9782 28.4196 22.7936 25.6066 25.6066C22.7936 28.4196 18.9782 30 15 30C11.0218 30 7.20644 28.4196 4.3934 25.6066C1.58035 22.7936 0 18.9782 0 15H0Z"
        fill={isActive ? "#9945EE" : "#C4C4C4"}
      />
      <path
        d="M32.325 12.5H36.25C36.5815 12.5 36.8995 12.6317 37.1339 12.8661C37.3683 13.1005 37.5 13.4185 37.5 13.75V36.25C37.5 36.5815 37.3683 36.8995 37.1339 37.1339C36.8995 37.3683 36.5815 37.5 36.25 37.5H13.75C13.4185 37.5 13.1005 37.3683 12.8661 37.1339C12.6317 36.8995 12.5 36.5815 12.5 36.25V32.325C11.6543 32.2034 10.8187 32.0195 10 31.775V36.25C10 37.2446 10.3951 38.1984 11.0983 38.9017C11.8016 39.6049 12.7554 40 13.75 40H36.25C37.2446 40 38.1984 39.6049 38.9017 38.9017C39.6049 38.1984 40 37.2446 40 36.25V13.75C40 12.7554 39.6049 11.8016 38.9017 11.0983C38.1984 10.3951 37.2446 10 36.25 10H31.775C32.0175 10.81 32.2 11.645 32.325 12.5Z"
        fill={isActive ? "#9945EE" : "#C4C4C4"}
      />
    </svg>
  );
};

export default ElementsIcon;
